// @flow
import {updateEvidenceRequest} from '@api/disputes';
import {
  selectSettingsMerchantID,
  selectTableCurrentPage,
  selectTableDisputesSort,
  selectTableFilter
} from '@reducers/disputes/selectors';
import {refreshDisputes} from './table';

const showMessage = ({type, text, setNotification}) => {
  if (typeof setNotification === 'function') {
    setNotification({type, text});
  }
};

// Action types
export const UPLOAD_EVIDENCE_REQUEST = 'UPLOAD_EVIDENCE_REQUEST';
export const UPLOAD_EVIDENCE_SUCCESS = 'UPLOAD_EVIDENCE_SUCCESS';
export const UPLOAD_EVIDENCE_FAILURE = 'UPLOAD_EVIDENCE_FAILURE';

export const DOWNLOAD_EVIDENCE_FILE_REQUEST = 'DOWNLOAD_EVIDENCE_FILE_REQUEST';
export const DOWNLOAD_EVIDENCE_FILE_SUCCESS = 'DOWNLOAD_EVIDENCE_FILE_SUCCESS';
export const DOWNLOAD_EVIDENCE_FILE_FAILURE = 'DOWNLOAD_EVIDENCE_FILE_FAILURE';

// Action creators
export const uploadEvidenceRequest = () => ({
  type: UPLOAD_EVIDENCE_REQUEST
});

export const uploadEvidenceSuccess = (disputeId, data) => ({
  type: UPLOAD_EVIDENCE_SUCCESS,
  payload: {
    disputeId,
    data
  }
});

export const uploadEvidenceFailure = error => ({
  type: UPLOAD_EVIDENCE_FAILURE,
  payload: {
    error
  }
});

export const downloadEvidenceFileRequest = () => ({
  type: DOWNLOAD_EVIDENCE_FILE_REQUEST
});

export const downloadEvidenceFileSuccess = () => ({
  type: DOWNLOAD_EVIDENCE_FILE_SUCCESS
});

export const downloadEvidenceFileFailure = error => ({
  type: DOWNLOAD_EVIDENCE_FILE_FAILURE,
  payload: {
    error
  }
});

export const submitChargebackProof = (disputeId, data, setNotification, messages) => async (
  dispatch,
  getState
) => {
  dispatch(uploadEvidenceRequest());
  const state = getState();
  const merchantID = selectSettingsMerchantID(state);

  try {
    // Files are already uploaded, just format them for the API
    const uploadedFiles = data.files.map(file => ({
      id: file.fileId,
      name: file.fileName
    }));

    const response = await updateEvidenceRequest(merchantID, disputeId, {
      text: data.text,
      files: uploadedFiles
    });

    dispatch(uploadEvidenceSuccess(disputeId, response));

    showMessage({
      type: 'success',
      text: messages.successText,
      setNotification
    });

    // Refresh disputes table after successful submission
    const currentState = getState();
    const filter = selectTableFilter(currentState);
    const sort = selectTableDisputesSort(currentState);
    const currentPage = selectTableCurrentPage(currentState);

    // Dispatch the refresh action with current parameters
    dispatch(refreshDisputes(merchantID, filter, sort, currentPage));
  } catch (error) {
    dispatch(uploadEvidenceFailure());
    showMessage({
      type: 'error',
      text: error.message, // Pass the translation key directly
      setNotification
    });
  }
};
